import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import {
  Box,
  Button,
  Grid,
  Modal,
  CircularProgress,
  FormHelperText,
} from "@material-ui/core";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import moment from "moment";
import { calculatePeriodLabelFromNumberOfDays } from "../../commonUtils/misc";

const useStyles = makeStyles((theme) => ({
  menu: {
    width: 200,
  },
  closeButtonCalendar: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "10px",
  },
  paddingCalendar: {
    padding: "5px",
  },
  calendar: {
    height: "100%",
    width: "80%",
    backgroundColor: "white",
    padding: "10px",
    borderRadius: "10px",
    overflowY: "auto",
    boxShadow: "0 0 20px rgba(0,0,0,0.3)",
    "@media (min-width: 768px)": {
      width: "60%",
      height: "auto",
      padding: "32px",
    },
  },
  textField6: {
    width: "calc(50% - 16px)",
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  textFieldTransparent: {
    width: "calc(50% - 16px)",
    margin: 8,
    "& .MuiInputBase-input": {
      backgroundColor: "transparent !important",
      border: "none !important",
    },
    "& label#docenteCode-label": {
      color: "#000000cc !important",
    },
  },
  datePickerTextField: {
    border: "none !important",
    background: "transparent !important",
    cursor: "pointer",
  },
  durationItem: {
    margin: "5px !important",
  },
  errorMessage: {
    color: "red !important",
  },
  centeredItem: {
    textAlign: "center !important",
  },
  buttonCancel: {
    marginBottom: "10px",
    "@media (min-width: 768px)": {
      marginRight: "10px",
      marginBottom: 0,
    },
  },
  title: {
    color: "var(--gc-ink)",
    fontWeight: "700",
    marginBottom: "8px",
  },
  input: {
    background: "#fff",
    "& input": {
      background: "transparent !important",
      border: "none !important",
    },
  },
  inputEmpty: {
    color: "var(--gc-ink-soft)",
    "& input::placeholder": {
      color: "var(--gc-ink-soft)",
    },
  },
  inputLabel: {
    fontSize: "14px",
    fontWeight: 600,
    color: "var(--gc-ink) !important",
    paddingLeft: "0 !important",
    display: "block",
  },
  columnGrid: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "end",
  },
  rowGrid: {
    display: "flex",
    alignItems: "center",
  },
  gridInner: {
    padding: "8px",
  },
}));

const RESORT_THEMES = [
  { value: 1, label: "Mare" },
  { value: 2, label: "Montagna" },
  { value: 3, label: "Terme" },
  { value: 4, label: "Altro" },
];

export const CATALOGS = [
  { value: 1, label: "Exchange experience" },
  { value: 2, label: "Study & Travel experience" },
  { value: 3, label: "Premium experience" },
];

export default function PackageSelector(props) {
  let [filteredDatePeriods, setFilteredDatePeriods] = useState(null);
  let [sourceDatePeriods, setSourceDatePeriods] = useState(null);
  let [showCalendar, setShowCalendar] = useState(false);
  let [durations, setDurations] = useState(null);
  const [firstCalendarDate, setFirstCalendarDate] = useState(new Date());
  const [selectedDuration, setSelectedDuration] = useState(null);
  const date = new Date();
  date.setMonth(date.getMonth() + 1);
  const [secondCalendarDate, setSecondCalendarDate] = useState(date);
  const [selectedTurnDate, setSelectedTurnDate] = useState(null);
  const [calendarModalOpen, setCalendarModalOpen] = useState(false);
  const [docenteCode, setDocenteCode] = useState("");

  const classes = useStyles();
  const {
    title = "Scegli il soggiorno",
    groupsTitle = "Programma",
    turnsTitle = "Seleziona il periodo",
    noTurnsText = "Non ci sono turni disponibili per questo pacchetto",
    departuresTitle = "Città di partenza",
    noDeparturesText = "Nessuna città disponibile",
    //structuresTitle = 'Seleziona la tipologia di camera',
    structuresTitle = "Seleziona il corso di lingua",
    programTypologiesTitle = "Tipologia di programma",
    noProgramTypologiesText = "Nessuna tipologia di programma disponibile",
    enableStructures = false,
    enableProgramTypologies = false,
    enableTurnPrice = false,
    enableResortTheme = false,
    enableCatalogs = false,
    enableDocenteCode,

    noPackagesAvailable,
    noDepartureServicesAvailable,
    noProgramTypologiesAvailable,

    clusterCode,

    onCatalogChange,
    onNationChange,
    onResortThemeChange,
    onWebGroupChange,
    onPackageChange,
    onDepartureServiceChange,
    onStructureChange,
    onProgramTypologyChange,
    onVerifyDocenteCode,
    state,
    applicationType,
  } = props;
  const {
    catalog = "",
    catalogs = [],
    nations = [],
    nation = "",
    resortTheme = "",
    webGroups = [],
    webGroup = "",
    packages = [],
    package: packageId = "",
    departureServices = [],
    departureService = "",
    structures = [],
    structure,
    programTypologies = [],
    programTypology,
  } = state;
  const errors = state.errors || {};
  const {
    nation: nationError = null,
    webGroup: webGroupError = null,
    package: packageError = null,
    catalog: catalogError = null,
    departureService: departureServiceError = null,
    structure: structureError,
    programTypology: programTypologyError,
  } = errors;

  // console.info("props", props);
  const isAdaForm = applicationType === "ada";

  const showStructuresField = isAdaForm
    ? true
    : enableStructures && structures.length > 0;

  useEffect(() => {
    if (packages.length > 0) {
      console.info("packages", packages);
      //show calendar is true if in all packages there are "packageType" === '24A661'
      showCalendar = packages.some(
        ({ packageType }) => packageType === "24A661"
      );
      setShowCalendar(showCalendar);
      if (showCalendar) {
        console.info("packages", packages);
        filteredDatePeriods = sourceDatePeriods = packages.map(
          ({ value, packageFrom, packageTo }) => {
            const dateFrom = moment(packageFrom, "DD/MM/YYYY");
            const dateTo = moment(packageTo, "DD/MM/YYYY");
            const days = dateTo.diff(dateFrom, "days");
            const label = calculatePeriodLabelFromNumberOfDays(days);
            return {
              id: value,
              dateFrom: dateFrom,
              textFieldPrint:
                "Dal " +
                dateFrom.format("DD/MM/YYYY") +
                " al " +
                dateTo.format("DD/MM/YYYY") +
                " (" +
                label +
                ")",
              dateTo: dateTo,
              duration: {
                days,
                label: label,
              },
            };
          }
        );
        durations = filteredDatePeriods.map(({ duration }) => duration);
        //rimuovi i duplicati di durations (days uguali) e ordina in maniera decrescente
        durations = durations
          .filter(
            (duration, index, self) =>
              index === self.findIndex((t) => t.days === duration.days)
          )
          .sort((a, b) => b.days - a.days);
        setFilteredDatePeriods(filteredDatePeriods);
        setSourceDatePeriods(filteredDatePeriods);
        setDurations(durations);

        //se esiste almeno una durata di 2 settimane, dev'essere preselezionata
        const twoWeeksDuration = durations.find((d) => d.days === 14);
        if (twoWeeksDuration) {
          setSelectedDuration(twoWeeksDuration);
        }

        //Il mese deve aprirsi già con la prima data disponibile
        //Ordino i periodi per data di inizio e prendo la prima data
        const firstPeriod = filteredDatePeriods.sort(
          (a, b) => a.dateFrom - b.dateFrom
        )[0];
        setFirstCalendarDate(firstPeriod.dateFrom.toDate());
        const newDate = new Date(firstPeriod.dateFrom.toDate());
        newDate.setMonth(newDate.getMonth() + 1);
        setSecondCalendarDate(newDate);

        console.info("datePeriods", filteredDatePeriods);
        console.info("durations", durations);
      }
    } else {
      //reset data
      setShowCalendar(false);
      setFilteredDatePeriods(null);
      setSourceDatePeriods(null);
      setDurations(null);
      setFirstCalendarDate(new Date());
      const newDate = new Date();
      date.setMonth(date.getMonth() + 1);
      setSecondCalendarDate(new Date());
      setSelectedTurnDate(null);
    }
  }, [packages]);

  useEffect(() => {
    if (selectedDuration) {
      console.info("selectedDuration num days", selectedDuration);
      //filtro tutti i periodi che hanno la stessa durata
      const periods = sourceDatePeriods.filter(
        ({ duration }) => duration.days === selectedDuration.days
      );
      console.info("periods", periods);
      setFilteredDatePeriods(periods);
    }
  }, [selectedDuration]);

  useEffect(() => {
    if (selectedTurnDate) {
      console.info("selectedTurnDate", selectedTurnDate);
      //prendo il periodo corretto
      const correctPeriod = filteredDatePeriods.find((d) =>
        d.dateFrom.isSame(selectedTurnDate, "day")
      );
      console.info("correctPeriod", correctPeriod);
      //stampo l'id
      console.info("selectedPeriodId", correctPeriod.id);
      //salvo il periodo
      onPackageChange(correctPeriod.id);
    }
  }, [selectedTurnDate]);

  const renderCalendar = ({ key, onChangeView, activeDate, value }) => (
    <Grid item sm={6} className={classes.paddingCalendar}>
      <Calendar
        tileDisabled={({ date, view }) => {
          if (
            view === "month" &&
            filteredDatePeriods.some((d) => d.dateFrom.isSame(date, "day"))
          ) {
            return false;
          }
          return true;
        }}
        tileClassName={({ date, view }) => {
          let classes = [];
          if (
            view === "month" &&
            filteredDatePeriods.some((d) => d.dateFrom.isSame(date, "day"))
          ) {
            classes.push("dayEnabled");
          }
          if (selectedTurnDate) {
            //imposta dayEnabled in tutte le date che sono uguali a selectedTurnDate e anche le date successive fino a dateTo dove dateFrom è uguale a selectedTurnDate
            const correctPeriod = filteredDatePeriods.find((d) =>
              d.dateFrom.isSame(selectedTurnDate, "day")
            );
            if (
              view === "month" &&
              date >= correctPeriod?.dateFrom &&
              date <= correctPeriod?.dateTo
            ) {
              classes.push("daySelected");
            }
          }

          return classes.length > 0 ? classes.join(" ") : null;
        }}
        key={key}
        onChange={(newDate) => setSelectedTurnDate(newDate)}
        onActiveStartDateChange={onChangeView}
        defaultActiveStartDate={activeDate}
        activeStartDate={activeDate}
        value={value}
      />
    </Grid>
  );

  return (
    <>
      <div className="booking-box">
        <div className="booking-box-shimmer" />
        <Typography variant="h4" className={classes.title}>
          {title}
        </Typography>

        <Grid container>
          {enableCatalogs && (
            <Grid item xs={12} sm={enableResortTheme ? 6 : 12}>
              <div className={classes.gridInner}>
                <label className={classes.inputLabel} htmlFor="catalog-type">
                  Seleziona tipo di catalogo *
                </label>
                <TextField
                  placeholder="Seleziona..."
                  variant="outlined"
                  id="catalog-type"
                  select
                  fullWidth
                  value={catalog}
                  error={catalogError}
                  onChange={(event) => onCatalogChange(event.target.value)}
                  SelectProps={{
                    MenuProps: {
                      className: classes.menu,
                    },
                    displayEmpty: true,
                  }}
                  margin="normal"
                  InputProps={{
                    className: `${classes.input} ${
                      !catalog ? classes.inputEmpty : ""
                    }`,
                  }}
                >
                  <MenuItem value="" disabled>
                    Seleziona...
                  </MenuItem>
                  {catalogs.map(({ value, label }) => (
                    <MenuItem key={value} value={value}>
                      {label}
                    </MenuItem>
                  ))}
                </TextField>
              </div>
            </Grid>
          )}

          {enableResortTheme && (
            <Grid
              item
              sm={enableCatalogs ? 6 : 12}
              xs={12}
              className={classes.columnGrid}
            >
              <div className={classes.gridInner}>
                <label
                  className={classes.inputLabel}
                  htmlFor="standard-vacancy-type"
                >
                  Seleziona il tipo di vacanza *
                </label>
                <TextField
                  placeholder="Seleziona..."
                  variant="outlined"
                  select
                  fullWidth
                  value={resortTheme}
                  error={nationError}
                  onChange={(event) => onResortThemeChange(event.target.value)}
                  SelectProps={{
                    MenuProps: {
                      className: classes.menu,
                    },
                    displayEmpty: true,
                  }}
                  InputProps={{
                    className: `${classes.input} ${
                      !resortTheme ? classes.inputEmpty : ""
                    }`,
                  }}
                  margin="normal"
                  id="standard-vacancy-type"
                >
                  <MenuItem value="" disabled>
                    Seleziona...
                  </MenuItem>
                  {RESORT_THEMES.map(({ value, label }) => (
                    <MenuItem key={value} value={value}>
                      {label}
                    </MenuItem>
                  ))}
                </TextField>
              </div>
            </Grid>
          )}

          {enableDocenteCode && (
            <Grid item sx={12} container>
              <Grid item xs={12} className={classes.rowGrid}>
                <div style={{ flex: 1 }} className={classes.gridInner}>
                  <label
                    className={classes.inputLabel}
                    htmlFor="docenteCode"
                    style={{ marginBottom: "9px" }}
                  >
                    Codice identificativo accompagnatore *
                  </label>
                  <TextField
                    placeholder="Seleziona..."
                    variant="outlined"
                    id="docenteCode"
                    value={docenteCode}
                    onChange={(event) => {
                      setDocenteCode(event.target.value);
                    }}
                    InputProps={{
                      className: `${classes.input} ${
                        !docenteCode ? classes.inputEmpty : ""
                      }`,
                    }}
                    fullWidth
                  />
                </div>
                <div className={classes.gridInner}>
                  <Button
                    disabled={
                      !docenteCode ||
                      docenteCode.length === 0 ||
                      (state && state.loadingDocentePackagesByCode)
                    }
                    variant="contained"
                    color={
                      docenteCode && docenteCode.length > 0
                        ? "primary"
                        : "default"
                    }
                    onClick={() => onVerifyDocenteCode(docenteCode)}
                  >
                    {state && state.loadingDocentePackagesByCode ? (
                      <CircularProgress size={18} color="inherit" />
                    ) : (
                      "Verifica codice"
                    )}
                  </Button>
                </div>
              </Grid>
              {state && state.docenteCodeError ? (
                <Grid item xs={12}>
                  <div className={classes.gridInner}>
                    <FormHelperText className={classes.errorMessage}>
                      {state.docenteCodeError}
                    </FormHelperText>
                  </div>
                </Grid>
              ) : null}
            </Grid>
          )}

          <Grid item sm={4} xs={12} className={classes.columnGrid}>
            <div className={classes.gridInner}>
              <label
                className={classes.inputLabel}
                htmlFor="standard-select-country"
              >
                {enableDocenteCode
                  ? "Paese di destinazione"
                  : isAdaForm
                  ? "Seleziona la tipologia di soggiorno *"
                  : "Seleziona paese di destinazione *"}
              </label>
              <TextField
                placeholder="Seleziona..."
                variant="outlined"
                id="standard-select-country"
                select
                disabled={enableDocenteCode}
                fullWidth
                value={nation || ""}
                error={nationError}
                onChange={(event) => onNationChange(event.target.value)}
                SelectProps={{
                  MenuProps: {
                    className: classes.menu,
                  },
                  displayEmpty: true,
                  IconComponent: enableDocenteCode ? () => null : undefined,
                }}
                InputProps={{
                  className: `${classes.input} ${
                    !nation ? classes.inputEmpty : ""
                  }`,
                }}
                margin="normal"
              >
                <MenuItem value="" disabled>
                  Seleziona...
                </MenuItem>
                {nations.map(({ value, label }) => (
                  <MenuItem key={value} value={value}>
                    {label}
                  </MenuItem>
                ))}
              </TextField>
            </div>
          </Grid>

          <Grid sm={8} xs={12} className={classes.columnGrid}>
            <div className={classes.gridInner}>
              <label
                className={classes.inputLabel}
                htmlFor="standard-select-package"
              >
                {groupsTitle} *
              </label>
              <TextField
                placeholder="Seleziona..."
                variant="outlined"
                id="standard-select-package"
                select
                fullWidth
                disabled={enableDocenteCode}
                value={webGroup || ""}
                error={webGroupError}
                onChange={(event) => onWebGroupChange(event.target.value)}
                SelectProps={{
                  MenuProps: {
                    className: classes.menu,
                  },
                  displayEmpty: true,
                  IconComponent: enableDocenteCode ? () => null : undefined,
                }}
                InputProps={{
                  className: `${classes.input} ${
                    !webGroup ? classes.inputEmpty : ""
                  }`,
                }}
                margin="normal"
              >
                <MenuItem value="" disabled>
                  Seleziona...
                </MenuItem>
                {webGroups.map(({ value, label }) => (
                  <MenuItem key={value} value={value}>
                    {label}
                  </MenuItem>
                ))}
              </TextField>
            </div>
          </Grid>
        </Grid>

        <Grid container>
          {/*La variabile è stata introdotta per mostrare il calendario per ADA*/}
          {showCalendar ? (
            <Grid item sm={8} xs={12} className={classes.columnGrid}>
              <div className={classes.gridInner}>
                <label
                  className={classes.inputLabel}
                  htmlFor="standard-date-turns"
                >
                  {turnsTitle} *
                </label>
                <TextField
                  placeholder="Seleziona..."
                  variant="outlined"
                  id="select-date-turns"
                  inputProps={{
                    readOnly: true,
                    className: classes.datePickerTextField,
                  }}
                  fullWidth
                  margin="normal"
                  value={
                    selectedTurnDate
                      ? filteredDatePeriods.find((d) =>
                          d.dateFrom.isSame(selectedTurnDate, "day")
                        )?.textFieldPrint
                      : ""
                  }
                  InputProps={{
                    className: classes.input,
                  }}
                  onClick={(_) => setCalendarModalOpen(true)}
                />

                {/*Modale che mostra il calendario di selezione per ADA*/}
                <Modal
                  open={calendarModalOpen}
                  onClose={(_) => setCalendarModalOpen(false)}
                >
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    height="100vh"
                  >
                    <Grid container item className={classes.calendar}>
                      <Grid container direction={"column"}>
                        <Grid container item>
                          {durations?.length > 0 && (
                            <Grid container item direction={"column"} xs={12}>
                              <Typography
                                className={classes.centeredItem}
                                variant={"button"}
                              >
                                Durata Soggiorno
                              </Typography>
                              <Grid
                                item
                                direction={"row"}
                                className={classes.centeredItem}
                              >
                                {durations?.map((item, index) => (
                                  <Button
                                    className={classes.durationItem}
                                    variant={
                                      selectedDuration?.label === item.label
                                        ? "outlinedSecondary"
                                        : "outlined"
                                    }
                                    size={"small"}
                                    key={index}
                                    onClick={() => setSelectedDuration(item)}
                                  >
                                    {item.label}
                                  </Button>
                                ))}
                              </Grid>
                            </Grid>
                          )}
                          <hr />
                          <Grid container direction={"column"} item md={12}>
                            <Typography
                              className={classes.centeredItem}
                              variant={"button"}
                            >
                              Seleziona Data di partenza
                            </Typography>
                            <Grid container item>
                              {renderCalendar({
                                key: "first-calendar",
                                onChangeView: (args) => {
                                  const { activeStartDate } = args;
                                  setFirstCalendarDate(activeStartDate);

                                  const newDate = new Date(activeStartDate);
                                  newDate.setMonth(newDate.getMonth() + 1);
                                  setSecondCalendarDate(newDate);
                                },
                                activeDate: firstCalendarDate,
                                value: selectedTurnDate,
                              })}
                              {renderCalendar({
                                key: "second-calendar",
                                onChangeView: (args) => {
                                  const { activeStartDate } = args;
                                  setSecondCalendarDate(activeStartDate);

                                  const newDate = new Date(activeStartDate);
                                  newDate.setMonth(newDate.getMonth() - 1);
                                  setFirstCalendarDate(newDate);
                                },
                                activeDate: secondCalendarDate,
                                value: selectedTurnDate,
                              })}
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid
                          item
                          container
                          className={classes.closeButtonCalendar}
                          direction={"row"}
                        >
                          <Button
                            className={classes.buttonCancel}
                            variant={"contained"}
                            onClick={() => {
                              setSelectedTurnDate(null);
                              setCalendarModalOpen(false);
                            }}
                          >
                            Annulla selezione e chiudi
                          </Button>
                          <Button
                            className={classes.buttonConfirm}
                            variant={"containedPrimary"}
                            onClick={() => setCalendarModalOpen(false)}
                          >
                            Conferma pacchetto
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Box>
                </Modal>
              </div>
            </Grid>
          ) : (
            <Grid item sm={8} xs={12} className={classes.columnGrid}>
              {noPackagesAvailable ? (
                <div className={classes.gridInner}>
                  <label
                    className={classes.inputLabel}
                    htmlFor="standard-select-turns"
                  >
                    {turnsTitle} *
                  </label>
                  <TextField
                    placeholder="Seleziona..."
                    variant="outlined"
                    id="standard-select-turns"
                    disabled
                    fullWidth
                    margin="normal"
                    value={noTurnsText}
                    InputProps={{
                      className: `${classes.input} ${
                        !noTurnsText ? classes.inputEmpty : ""
                      }`,
                    }}
                  />
                </div>
              ) : (
                <div className={classes.gridInner}>
                  <label
                    className={classes.inputLabel}
                    htmlFor="standard-select-turns"
                  >
                    {enableDocenteCode ? "Periodo" : `${turnsTitle} *`}
                  </label>
                  <TextField
                    placeholder="Seleziona..."
                    variant="outlined"
                    id="standard-select-turns"
                    select
                    disabled={enableDocenteCode}
                    fullWidth
                    value={packageId || ""}
                    error={packageError}
                    onChange={(event) => onPackageChange(event.target.value)}
                    SelectProps={{
                      MenuProps: {
                        className: classes.menu,
                      },
                      displayEmpty: true,
                      IconComponent: enableDocenteCode ? () => null : undefined,
                    }}
                    InputProps={{
                      className: `${classes.input} ${
                        !packageId ? classes.inputEmpty : ""
                      }`,
                    }}
                    margin="normal"
                  >
                    <MenuItem value="" disabled>
                      Seleziona...
                    </MenuItem>
                    {packages
                      // .slice(0, 3)
                      .map(
                        ({
                          value,
                          label,
                          price,
                          allPricesForMemberCluster,
                          soldout,
                        }) => {
                          let finalPrice = price;
                          if (
                            clusterCode &&
                            allPricesForMemberCluster &&
                            allPricesForMemberCluster[clusterCode]
                          ) {
                            const cluster =
                              allPricesForMemberCluster[clusterCode];
                            finalPrice =
                              cluster.price != null ? cluster.price : price;
                          }
                          return (
                            <MenuItem
                              disabled={soldout}
                              key={value}
                              value={value}
                            >
                              {label}
                              {/* @Agata qui si nasconde il prezzo */}
                              {!soldout &&
                                enableTurnPrice &&
                                finalPrice > 0 && (
                                  <span>
                                    &nbsp;- €{(finalPrice || 0) / 100}
                                  </span>
                                )}
                              {soldout && <span>&nbsp;- SOLDOUT</span>}
                            </MenuItem>
                          );
                        }
                      )}
                  </TextField>
                </div>
              )}
            </Grid>
          )}

          <Grid item sm={4} xs={12} className={classes.columnGrid}>
            <div className={classes.gridInner}>
              <label
                className={classes.inputLabel}
                htmlFor="standard-select-checkin"
              >
                {departuresTitle} *
              </label>
              {noDepartureServicesAvailable ? (
                <TextField
                  placeholder="Seleziona..."
                  variant="outlined"
                  id="standard-select-checkin"
                  disabled
                  fullWidth
                  margin="normal"
                  value={noDeparturesText}
                  InputProps={{
                    className: `${classes.input} ${
                      !noDeparturesText ? classes.inputEmpty : ""
                    }`,
                  }}
                />
              ) : (
                <TextField
                  placeholder="Seleziona..."
                  variant="outlined"
                  id="standard-select-checkin"
                  select
                  fullWidth
                  value={departureService || ""}
                  error={departureServiceError}
                  onChange={(event) =>
                    onDepartureServiceChange(event.target.value)
                  }
                  disabled={noPackagesAvailable}
                  SelectProps={{
                    MenuProps: {
                      className: classes.menu,
                    },
                    displayEmpty: true,
                  }}
                  margin="normal"
                  InputProps={{
                    className: `${classes.input} ${
                      !departureService ? classes.inputEmpty : ""
                    }`,
                  }}
                >
                  <MenuItem value="" disabled>
                    Seleziona...
                  </MenuItem>
                  {departureServices.map(({ value, label, soldout }) => (
                    <MenuItem disabled={soldout} key={value} value={value}>
                      {soldout ? `${label} - SOLDOUT` : label}
                    </MenuItem>
                  ))}
                </TextField>
              )}
            </div>
          </Grid>
          {showStructuresField && (
            <Grid
              item
              sm={enableProgramTypologies ? 6 : 12}
              xs={12}
              className={classes.columnGrid}
            >
              <div className={classes.gridInner}>
                <label
                  className={classes.inputLabel}
                  htmlFor="standard-select-checkin"
                >
                  {structuresTitle} *
                </label>
                <TextField
                  placeholder="Seleziona..."
                  variant="outlined"
                  id="standard-select-checkin"
                  select
                  fullWidth
                  value={structure || ""}
                  error={structureError}
                  onChange={(event) => onStructureChange(event.target.value)}
                  SelectProps={{
                    MenuProps: {
                      className: classes.menu,
                    },
                    displayEmpty: true,
                  }}
                  InputProps={{
                    className: `${classes.input} ${
                      !structure ? classes.inputEmpty : ""
                    }`,
                  }}
                  margin="normal"
                >
                  <MenuItem value="" disabled>
                    Seleziona...
                  </MenuItem>
                  {structures.map(({ value, label }) => (
                    <MenuItem key={value} value={value}>
                      {label}
                    </MenuItem>
                  ))}
                </TextField>
              </div>
            </Grid>
          )}

          {enableProgramTypologies && (
            <Grid item sm={6} xs={12} className={classes.columnGrid}>
              {noProgramTypologiesAvailable ? (
                <div className={classes.gridInner}>
                  <label
                    className={classes.inputLabel}
                    htmlFor="standard-select-checkin"
                  >
                    {programTypologiesTitle} *
                  </label>
                  <TextField
                    variant="outlined"
                    id="standard-select-checkin"
                    fullWidth
                    select
                    margin="normal"
                    InputProps={{
                      className: `${classes.input} ${
                        !noProgramTypologiesText ? classes.inputEmpty : ""
                      }`,
                    }}
                    SelectProps={{
                      MenuProps: {
                        className: classes.menu,
                      },
                      displayEmpty: true,
                    }}
                    value={noProgramTypologiesText}
                  >
                    <MenuItem value={noProgramTypologiesText} disabled>
                      {noProgramTypologiesText}
                    </MenuItem>
                  </TextField>
                </div>
              ) : (
                <div className={classes.gridInner}>
                  <label
                    className={classes.inputLabel}
                    htmlFor="standard-select-checkin"
                  >
                    {programTypologiesTitle} *
                  </label>
                  <TextField
                    variant="outlined"
                    id="standard-select-checkin"
                    select
                    fullWidth
                    value={programTypology || ""}
                    error={programTypologyError}
                    onChange={(event) =>
                      onProgramTypologyChange(event.target.value)
                    }
                    SelectProps={{
                      MenuProps: {
                        className: classes.menu,
                      },
                      displayEmpty: true,
                    }}
                    InputProps={{
                      className: `${classes.input} ${
                        !programTypology ? classes.inputEmpty : ""
                      }`,
                    }}
                    margin="normal"
                  >
                    <MenuItem value="" disabled>
                      Seleziona...
                    </MenuItem>
                    {programTypologies.map(({ value, label }) => (
                      <MenuItem key={value} value={value}>
                        {label}
                      </MenuItem>
                    ))}
                  </TextField>
                </div>
              )}
            </Grid>
          )}
        </Grid>
      </div>
    </>
  );
}

PackageSelector.propTypes = {
  title: PropTypes.string,
  groupsTitle: PropTypes.string,
  turnsTitle: PropTypes.string,
  noTurnsText: PropTypes.string,
  departuresTitle: PropTypes.string,
  noDeparturesText: PropTypes.string,
  structuresTitle: PropTypes.string,
  programTypologiesTitle: PropTypes.string,
  noProgramTypologiesText: PropTypes.string,
  enableStructures: PropTypes.bool,
  enableProgramTypologies: PropTypes.bool,
  enableTurnPrice: PropTypes.bool,

  noPackagesAvailable: PropTypes.bool.isRequired,
  noDepartureServicesAvailable: PropTypes.bool.isRequired,
  noProgramTypologiesAvailable: PropTypes.bool,

  state: PropTypes.shape({
    nations: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
      })
    ),
    nation: PropTypes.string,
    webGroups: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
      })
    ),
    webGroup: PropTypes.string,
    packages: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.number.isRequired,
        label: PropTypes.string.isRequired,
        price: PropTypes.number.isRequired,
        allPricesForMemberCluster: PropTypes.object,
      })
    ),
    // loadingTurns: PropTypes.bool.isRequired,
    package: PropTypes.number,
    departureServices: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        price: PropTypes.number.isRequired,
        soldout: PropTypes.bool,
      })
    ),
    // loadingDepartureServices: PropTypes.bool.isRequired,
    departureService: PropTypes.string,
    structures: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        price: PropTypes.number.isRequired,
      })
    ),
    structure: PropTypes.string,
    programTypologies: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
      })
    ),
    programTypology: PropTypes.string,
    errors: PropTypes.shape({
      nation: PropTypes.string,
      webGroup: PropTypes.string,
      package: PropTypes.string,
      departureService: PropTypes.string,
      structure: PropTypes.string,
      programTypology: PropTypes.string,
    }),
  }).isRequired,
  clusterCode: PropTypes.string,

  onNationChange: PropTypes.func.isRequired,
  onWebGroupChange: PropTypes.func.isRequired,
  onPackageChange: PropTypes.func.isRequired,
  onDepartureServiceChange: PropTypes.func.isRequired,
  onStructureChange: PropTypes.func,
  onProgramTypologyChange: PropTypes.func,
  onVerifyDocenteCode: PropTypes.func,
};
